import React from 'react'

type Props = {
  level: 1 | 2 | 3
  style?: React.CSSProperties
}

const COLOR = {
  1: ['#07C160', '#A6F5C2', '#E6FFEE'],
  2: ['#FF8800', '#FFE0A3', '#FFF7E6'],
  3: ['#FF4D4F', '#FFCCC7', '#FFF2F0'],
}

const LEVEL_MAP = {
  1: '初',
  2: '中',
  3: '高',
}

export default function LevelTextIcon({ level, style }: Props) {
  if (level === 0) {
    return <span> </span>
  }
  return (
    <span
      id="level-text-icon"
      style={{
        fontSize: 10,
        border: '1px solid',
        borderRadius: '2px',
        width: 14,
        height: 14,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: COLOR[level][0],
        borderColor: COLOR[level][1],
        background: COLOR[level][2],
        ...style,
      }}
    >
      {LEVEL_MAP[level]}
    </span>
  )
}
